import React, { Component } from 'react';

import './style.sass';
import CommonUsualText from '../../../common-components/common-usual-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Task extends Component {
    render() {
        return (
            <div className="gapresource-task">
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <div className="gapresource-task__inner">
                        <div className="gapresource-task__goal">Цель</div>
                        <CommonUsualText className="gapresource-task__text">
                            Разработать современный, функциональный и адаптивный корпоративный сайт
                            на русском и английском языках, лендинговые версии на китайском и
                            арабском языках с возможностями SEO-продвижения.
                        </CommonUsualText>
                    </div>
                </ScrollAnimation>
            </div>
        );
    }
}

export default Task;
